module.exports = __webpack_public_path__ + "fonts/DIN_Alternate.2dbc231e.ttf";